import { PayloadAction } from "@reduxjs/toolkit";
import { ISearchBudget, ISearchRequest, ISearchSingle, IStoreDetailData } from "../models";
import { AxiosResponse } from "axios";
import { IStoreDataModel } from "../models";
import { all, call, put, takeLatest } from "redux-saga/effects";
import { mockupApis } from "../mockupApi";
import { searchStoreActions } from "./searchStoreSlice";
import { DataResponse } from "utils/commonModels";
import { storesApi } from "../storeApi";
import { deepJSONParse } from "helpers/convertStrToJson";

function* fetchStoreList(action: PayloadAction<ISearchRequest>) {
  try {
    const response: AxiosResponse<DataResponse<IStoreDetailData[]>> = yield call(
      storesApi.search,
      action.payload
    );
    if (response && response.status === 200) {
      const returnData = deepJSONParse(response.data.body.data);
      yield put(searchStoreActions.getStoresSuccess(returnData));
    } else {
      console.log("Failed to fetch store list", response.statusText);
      yield put(searchStoreActions.fetchDataFailed(response.statusText));
    }
  } catch (error: any) {
    console.log("Failed to fetch store list", error);
    yield put(searchStoreActions.fetchDataFailed(error));
  }
}

function* fetchStoreByBudget(action: PayloadAction<ISearchBudget>) {
  try {
    const response: AxiosResponse<DataResponse<IStoreDetailData[]>> = yield call(
      storesApi.searchByBudget,
      action.payload
    );
    const returnData = deepJSONParse(response.data.body.data);
    if (response && response.status === 200) {
      yield put(searchStoreActions.getByBudgetSuccess(returnData));
    } else {
      console.log("Failed to fetch store list", response.statusText);
      yield put(searchStoreActions.fetchDataFailed(response.statusText));
    }
  } catch (error: any) {
    console.log("Failed to fetch store list", error);
    yield put(searchStoreActions.fetchDataFailed(error));
  }
}

function* fetchStoreSingle(action: PayloadAction<ISearchSingle>) {
  try {
    const response: AxiosResponse<DataResponse<IStoreDetailData[]>> = yield call(
      storesApi.listStoreSingle,
      action.payload
    );
    console.log(action.payload)
    if (response && response.status === 200) {
      yield put(searchStoreActions.getStoresSuccess(response.data.body.data));
    } else {
      console.log("Failed to fetch store list", response.statusText);
      yield put(searchStoreActions.fetchDataFailed(response.statusText));
    }
  } catch (error: any) {
    console.log("Failed to fetch store list", error);
    yield put(searchStoreActions.fetchDataFailed(error));
  }
}

export function* searchStoreSaga() {
  yield all([takeLatest(searchStoreActions.searchStore.type, fetchStoreList)]);
  yield all([takeLatest(searchStoreActions.searchByBudget.type, fetchStoreByBudget)]);
  yield all([takeLatest(searchStoreActions.searchSingle.type, fetchStoreSingle)]);
}
